import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(private)/profile/[tab]/page.tsx")